import HouseCardGeoTitle from './HouseCardGeoTitle'

export { HouseCardGeoTitle }
